var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrapeauFrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.566051 14.3937C2.36806 14.79 4.1701 14.7754 5.9721 14.6144V14.6096C9.725 14.2476 13.4779 13.191 17.2308 14.0435C17.5804 14.1229 17.9163 13.8716 17.9163 13.532V3.12301C17.9163 3.10202 17.9146 3.0814 17.912 3.06098C17.8261 2.84629 17.6249 2.65946 17.3905 2.60813C13.9645 1.85481 10.5386 2.58522 7.11261 2.98661C6.73246 3.03482 6.35232 3.07868 5.97217 3.11537V3.10541C4.17017 3.26638 2.36813 3.28092 0.566122 2.88467C0.253442 2.81621 0 2.98555 0 3.28099V13.7208C0 14.0159 0.253442 14.3253 0.566051 14.3937Z",
    fill: "#0B67B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9174 3.07314C17.8343 2.85337 17.6304 2.66026 17.3915 2.60797C15.5761 2.2088 13.7607 2.22646 11.9453 2.39082V13.8999C13.7607 13.7355 15.5761 13.7179 17.3915 14.117C17.6304 14.1693 17.8343 14.0825 17.9174 13.9069V3.07314Z",
    fill: "#FF473E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96875 14.6141C7.95944 14.4363 9.95016 14.0799 11.9409 13.8997V2.39062C9.95016 2.57085 7.95944 2.92722 5.96875 3.10506V14.6141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrapeauFrance);
export default __webpack_public_path__ + "static/media/drapeau France.6149724c96fde2ce2fc62ba7ec319622.svg";
export { ForwardRef as ReactComponent };